var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewcatalogsearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3269 15.44L18.8 18.8M17.68 9.84C17.68 14.1699 14.1699 17.68 9.84 17.68C5.51009 17.68 2 14.1699 2 9.84C2 5.51009 5.51009 2 9.84 2C14.1699 2 17.68 5.51009 17.68 9.84Z",
    stroke: "#A4A4A4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcatalogsearchicon);
export default __webpack_public_path__ + "static/media/newcatalogsearchicon.e83ddb2994a19441781cd8c1f3ffd529.svg";
export { ForwardRef as ReactComponent };